import React, { Component } from 'react';

export default class KpisSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      showFilter: false,
    };
  }

  render() {
    return (
      <div className='Stats'>
        { this.props.indicadores.map((row,i)=>(
          <div className='squareStats' key={i}>
            <p className='squareStats-number'>{row.totalIndi}</p>
            <p className='squareStats-title'>{row.desIndi}</p>
          </div>
        ))
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/FichaEntrega/KpisSection.js